import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BookSubjects from '../../../Books/BookSubjects';
import BookTestsAccordion from '../../../Books/BookTestsAccordion';
import ClassQuestion from '../../../ClassQuestion/ClassQuestion';
import { useQuizGoingOn } from '../../../Context/QuizGoingOn';
import Moretest from '../../../Moretest/Moretest';
import Mycourse from '../../../Mycourse/MyCourses';
import MySessions from '../../../MySessions/MySessions';
import Mytest from '../../../Mytest/Mytest';
import Prelim from '../../../Prelims/Prelims';
import Security from '../../../Security/Security';
import Setting from '../../../Settings/Setting';
import Subscribemore from '../../../Subscribemore/Subscribemore';
import CivilCard from '../CivilCard/CivilCard';
import CivilFeature from '../CivilFeature/CivilFeature';
import CivilOverview from '../CivilOverview/CivilOverview';
import CivilPop from '../CivilPop/CivilPop';
import CivilSchedule from '../CivilSchedule/CivilSchedule';
import Toggle from '../CivilTestToggle/CivilTestToggle';
import CivilToggle from '../CivilToggle/CivilToggle';
import "./CivilButton.css";
import LessonNotes from '../../../Books/BookLessons/LessonNotes';
import ClassVideo from '../../../Books/BookLessons/ClassVideo';
import LessonQuiz from '../../../Books/BookLessons/LessonQuiz';
import LanguageSubjectsTestList from '../../../CUET/LanguageSubjects/LanguageSubjectsTest';
import CUET_Dashboard from '../../../CUET/Dashboard/CUET_Dashboard';
import DomainSpecificSubjectsTestList from '../../../CUET/DomainSpecificSubjects/DomainSpecificSubjectsTests';
import NeetAllSubjectsTestList from '../../NEET/NeetAllSubjects/NeetAllSubjectsTests';
import PhysicsTestList from '../../NEET/PhysicsTestList';
import NeetDashboard from '../../NEET/NeetDashboard';
import GENERAL_APTITUDE_List from '../../../UGC_NET/GENERAL_APTITUDE/GENERAL_APTITUDE_List';
import UGC_Dashboard from '../../../UGC_NET/UGC_Dashboard';
import LiveClassesHome from '../../../live_streaming/LiveClassesHome';

// only recieving/using moduleName when redirecting to dashboard after payment success
function CivilButton({ setOpenPaymentModal, testSeriesData, courseData, newsData, lessonData, bookData, moduleName, componentName, heading, userDtails, ExamType, CUET_Tests, loadingCUETTests, CUET_SubjectType, selectSectionII_Subject, selectSectionII_Plan, sectionIIsubjects, prePath, NEET_Tests, Neet_Subject, overView, enrolled, UGC_Subject, UGC_Tests, onTakeTest, selectedClass }) {
    const location = useLocation();
    const [teacher, SetTeacher] = useState(false);
    const [upload, SetUpload] = useState(false);
    const [activeButton, setActiveButton] = useState(''); //Track active button
    const [buttonNames, setButtonNames] = useState([]); //Manage All button Name Array
    const [isQuizGoingOn, setIsQuizGoingOn] = useQuizGoingOn();
    const navigate = useNavigate();
    const selectButton = () => {
        if (moduleName) {
            if (moduleName == 'course') {
                return 2;
            } else if (moduleName == 'cuet') {
                return 2;
            } else if (moduleName == 'neet') {
                return 2;
            } else {
                return 4;
            }
        } else {
            return 2;
        }
    }



    const ctype1 = "question"
    const ctype2 = "upload"

    const getDashboardButtonNames = () => {
        const type = (userDtails?.ExamType || '').toLowerCase();
        const mod = (moduleName || '').toLowerCase();

        if (prePath?.includes('cuet') || type === 'cuet' || mod === 'cuet') {
            return ['Settings', 'Security', 'CUET Tests'];
        } else if (prePath?.includes('neet') || type === 'neet' || mod === 'neet') {
            return ['Settings', 'Security', 'NEET Tests'];
        } else if (prePath?.includes('ugc') || type === 'ugc-net' || mod === 'ugc') {
            return ['Settings', 'Security', 'Enrolled Tests'];
        }
        return ['Settings', 'Security', /* 'My Sessions', 'CUET Tests', */ 'My Courses', 'Live Classes', 'Subscribe More Courses', 'My Test Series', 'Subscribe More Test Series'];
    }
    useEffect(() => {
        // Map component names to button labels
        const buttonLabels = {
            'civilHistory': courseData?.CourseID === '1749468128241YDnrK9x' ? ['Introduction', 'Sessions', 'Current Developments', 'Teacher Support', /* 'Upload Answers' */] : ['Features', 'Classes', 'Current Developments', 'Teacher Support', 'Upload Answers'],//cutomized for INSIGHT Mentorship Programme course
            'civilTest': ['Overview', 'Test', 'Schedule', 'Teacher Support'],
            'dashboard': getDashboardButtonNames(),
            'CourseDescriptionprelimstest': courseData?.CourseID === '1749468128241YDnrK9x' ? ['MCQs', 'Mains Questions', 'Teacher Support'] : ['Class Questions', 'Prelims', 'Teacher Support', 'Upload Answers'],
            'CourseDescription': courseData?.CourseID === '1749468128241YDnrK9x' ? ['MCQs', 'Mains Questions', 'Teacher Support'] : ['Class Questions', 'Teacher Support', 'Upload Answers'],
            'PrelimsDescription': courseData?.CourseID === '1749468128241YDnrK9x' ? ['MCQs', 'Mains Questions', 'Teacher Support'] : ['Prelims', 'Teacher Support', 'Upload Answers'],
            'WithoutPrelimsDescription': ['Teacher Support', 'Upload Answers'],
            'book': ['Introduction', 'Book Chapters', 'Connect with Author', 'Practice Test'],
            'bookTestSeries': ['Overview', 'Practice Tests'],
            'bookLessonPage': ['Subjective Questions', 'Practice MCQs', 'Chapter Video'],
            'Language Subjects': ['Overview', 'Language Subjects Tests',],
            'Domain-Specific Subjects': ['Overview', 'Domain-Specific Subjects Tests'/* ,'Overview' */],
            'General Aptitude Test': ['Overview', 'General Aptitude Test Tests',],
            'Physics_Tests': ['Overview', 'Physics Tests',/* , 'Dashboard' */],
            'Chemistry_Tests': ['Overview', 'Chemistry Tests',/* , 'Dashboard' */],
            'Zoology_Tests': ['Overview', 'Zoology Tests',/* , 'Dashboard' */],
            'Botany_Tests': ['Overview', 'Botany Tests',/* , 'Dashboard' */],
            'Combined_Tests': ['Overview', 'Combined Tests',/* , 'Dashboard' */],
            'NEET All Subjects': ['Overview', 'NEET All Subjects Tests'],
            'GENERAL': ['Overview', 'General Aptitude',/* , 'Dashboard' */],
            'COMBINED': ['Overview', 'Combined Tests',/* , 'Dashboard' */],

            // Add more component names and their associated button labels as needed
        };
        const defaultButtons = buttonLabels['civilHistory']; // Default to civilHistory if componentName doesn't match
        const buttons = buttonLabels[componentName] || defaultButtons;

        setButtonNames(buttons);

        const storedTab = sessionStorage.getItem(`activeTab_${componentName}`);
        if (storedTab && buttons.some(b => b?.toLowerCase()?.replace(/\s+/g, '') === storedTab)) {
            setActiveButton(storedTab);
            if (storedTab === 'uploadanswers') {
                SetTeacher(false);
                SetUpload(true);
            } else if (storedTab === 'teachersupport') {
                SetTeacher(true);
                SetUpload(false);
            }
            return;
        }

        // Manage Default State of Feature and Overview Content According to ComponentName
        switch (componentName) {
            case 'civilHistory':
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'civilTest':
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'dashboard':
                setActiveButton(buttons[selectButton()]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'CourseDescription':
                setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'CourseDescriptionprelimstest':
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'PrelimsDescription':
                setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'WithoutPrelimsDescription':
                SetTeacher(true);
                setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'book':
                SetTeacher(true);
                setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'bookTestSeries':
                SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'bookLessonPage':
                // SetTeacher(true);
                setActiveButton(buttons[0]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Language Subjects':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Domain-Specific Subjects':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'General Aptitude Test':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Physics_Tests':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Chemistry_Tests':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Zoology_Tests':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Botany_Tests':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'Combined_Tests':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'GENERAL':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'COMBINED':
                // SetTeacher(true);
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            case 'NEET All Subjects':
                setActiveButton(buttons[1]?.toLowerCase()?.replace(/\s+/g, '') || '');
                break;
            default:
                break;
        }
        setButtonNames(buttons);
    }, [componentName, moduleName, prePath]);
    const handleButtonClick = (buttonName) => {
        const buttontext = buttonName.toLowerCase().replace(/\s+/g, '');
        if (buttontext == 'practicetest') {
            navigate(`/books/practice-test/${bookData.urlTitle}`)
            return;
        } else if (buttontext == 'dashboard') {
            navigate('/StudentDashboard', { state: { prePath: location.pathname } })
        }
        console.log(buttontext);
        setActiveButton(buttontext);
        sessionStorage.setItem(`activeTab_${componentName}`, buttontext);

    };
    return (
        <>
            {/* Civil Button Section Start */}
            <div className='Civilbutton-background'>
                <div className='p-3 bg-gray'>
                    <div className="civilbutton-Container">
                        {buttonNames.map((name, index) => (
                            <button
                                key={index}
                                disabled={(name == 'Teacher Support' || name == 'Upload Answers' || name == 'Class Questions') && isQuizGoingOn}
                                className={`btn me-2 ${activeButton === name.toLowerCase().replace(/\s+/g, '') ? 'activebutton' : "bg-white"}`}
                                onClick={
                                    () => {
                                        handleButtonClick(name)
                                        switch (name) {
                                            case 'Teacher Support':
                                                // Handle Teacher Support accordingly
                                                SetTeacher(true)
                                                SetUpload(false)
                                                break;
                                            case 'Upload Answers':
                                                // Handle Upload Answers accordingly
                                                SetTeacher(false)
                                                SetUpload(true)
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                }
                                type="button">{name}</button>
                        ))}
                    </div>

                </div>
                {/* Display Information Section Start */}
                <div className='Civilinfo-display'>
                    {/* ************************Civil History Component Start************************************ */}
                    {/* Civil Feature Section Start */}
                    {activeButton === 'features' && <div className='px-4 bg-cream'><CivilFeature paragraphs={courseData?.Description} /></div>}
                    {/* Civil Feature Section  End */}
                    {/* Civil Toggle Section Start  */}
                    {activeButton === 'classes' && <div className=''><CivilToggle courseData={courseData} /></div>}
                    {activeButton === 'sessions' && <div className=''><CivilToggle courseData={courseData} /></div>}
                    {activeButton === 'introduction' && <div className='px-4 bg-cream'><CivilFeature paragraphs={bookData?.topics || courseData?.Description} /></div>}
                    {activeButton === 'bookchapters' && <div className=''><BookSubjects bookData={bookData} /></div>}
                    {activeButton === 'practicetests' && <BookTestsAccordion bookData={bookData} />}
                    {activeButton === 'subjectivequestions' && <LessonNotes paragraphs={lessonData?.Description} />}
                    {activeButton === 'practicemcqs' && <LessonQuiz lessonData={lessonData} bookData={bookData} />}
                    {activeButton === 'chaptervideo' && <ClassVideo VideoURL={lessonData?.VideoID} />}
                    {/* Civil Toggle Section End */}
                    {/* Civil Card Section Start */}
                    {activeButton === 'currentdevelopments' && <div className='px-4 ps-4'><CivilCard CardData={newsData} /></div>}
                    {/* Civil Card Section End */}
                    {/* Civil Pop Section Start */}
                    {activeButton === 'connectwithauthor' && <CivilPop isEnrolled={'enrolled'} ctype1={ctype1} ctype2={''} isteacher={teacher} iscourseid={bookData?.coursId} title={bookData?.title} />}

                    {activeButton === 'teachersupport' && <CivilPop isEnrolled={courseData?.isEnrolled || testSeriesData?.isEnrolled || 'enrolled'} ctype1={ctype1} ctype2={''} isteacher={teacher} iscourseid={courseData?.CourseID || testSeriesData?.CourseID} title={lessonData?.Title || courseData?.CourseTitle || testSeriesData?.Title} />}

                    {activeButton === 'uploadanswers' && <CivilPop isEnrolled={courseData?.isEnrolled} ctype1={''} ctype2={ctype2} isupload={upload} title={lessonData?.Title || courseData?.CourseTitle || testSeriesData?.Title} iscourseid={courseData?.CourseID || testSeriesData?.CourseID} />}
                    {/* Civil Pop Section End */}
                    {/* *************************Civil History Component End*************************************** */}
                    {/* *************************Civil Test Component Start**************************************** */}
                    {/* Civil Overview Section Start */}
                    {activeButton === 'overview' && <CivilOverview paragraphs={testSeriesData?.Description || bookData?.description || overView || 'No overview available'} />}
                    {/* Civil Overview Section End */}
                    {/* Toggle Section Start */}
                    {activeButton === 'test' && <Toggle testSeriesData={testSeriesData} setOpenPaymentModal={setOpenPaymentModal} />}
                    {(activeButton === 'languagesubjectstests' || activeButton === 'generalaptitudetesttests') && <LanguageSubjectsTestList ExamType={ExamType} tests={CUET_Tests} loadingTests={loadingCUETTests} CUET_SubjectType={CUET_SubjectType} enrolled={enrolled} onTakeTest={onTakeTest} />}
                    {activeButton === 'domain-specificsubjectstests' && <DomainSpecificSubjectsTestList handleSelectSubject={selectSectionII_Subject} handlePlanSelect={selectSectionII_Plan} subjects={sectionIIsubjects} />}
                    {activeButton === 'neetallsubjectstests' && <NeetAllSubjectsTestList subject={Neet_Subject} tests={NEET_Tests} enrolled={enrolled} onTakeTest={onTakeTest} />}
                    {['physicstests', 'chemistrytests', 'botanytests', 'zoologytests', 'combinedtests']?.includes(activeButton) && <PhysicsTestList subject={Neet_Subject} tests={NEET_Tests} enrolled={enrolled} />}
                    {activeButton === 'neettests' && <NeetDashboard />}

                    {/* UGC NET */}
                    {['generalaptitude', 'combinedtests']?.includes(activeButton) && <GENERAL_APTITUDE_List subject={UGC_Subject} tests={UGC_Tests} enrolled={enrolled} onTakeTest={onTakeTest} />}
                    {activeButton === 'enrolledtests' && <UGC_Dashboard />}


                    {/* Toggle Section End */}
                    {/* Civil Schedule Section Start */}
                    {activeButton === 'schedule' && <CivilSchedule testSeriesData={testSeriesData} />}
                    {/* Civil Schedule Section End */}
                    {/* *************************Civil Test Component End*************************************** */}
                    {/* *************************Dashboard Component Start**************************************** */}
                    {/*Settings Section Start */}
                    {activeButton === 'settings' && <Setting userDtails={userDtails} />}
                    {/*Settings Section End */}
                    {/*Security Section Start */}
                    {activeButton === 'security' && <Security />}
                    {/*Security Section End */}
                    {/*My Courses Section Start */}
                    {activeButton === 'mycourses' && <Mycourse heading={heading} />}
                    {activeButton === 'liveclasses' && <LiveClassesHome />}
                    {activeButton === 'mysessions' && <MySessions />}
                    {activeButton === 'cuettests' && <CUET_Dashboard />}
                    {/*My Courses Section End */}
                    {/*Subscribe More Courses Section Start */}
                    {activeButton === 'subscribemorecourses' && <Subscribemore heading={heading} />}
                    {/*Subscribe More Courses Section End */}
                    {/*My Test Series Section Start */}
                    {activeButton === 'mytestseries' && <Mytest heading2={heading} />}
                    {/*My Test Series Section End */}
                    {/*Subscribe More Test Series Section Start */}
                    {activeButton === 'subscribemoretestseries' && <Moretest heading2={heading} />}
                    {/*Subscribe More Test Series Section End */}
                    {/* *************************Dashboard Component End*************************************** */}
                    {/* *************************Course Description Component Start**************************************** */}
                    {/*Settings Section Start */}
                    {(activeButton === 'classquestions' || activeButton == 'mainsquestions') && <ClassQuestion paragraphs={lessonData?.Description} />}
                    {/*Settings Section End */}
                    {/* *************************Course Description Component End*************************************** */}
                    {/* *************************Prelims Component Start**************************************** */}
                    {/*Settings Section Start */}
                    {(activeButton === 'prelims' || activeButton === 'mcqs') && <Prelim lessonData={lessonData} courseData={courseData} />}
                    {/*Settings Section End */}
                    {/* *************************Prelims Component End*************************************** */}
                </div>
                {/* Display Information Section End */}
            </div>
            {/* Civil Button Section End */}
        </>
    )
}

export default CivilButton;